import { DealsLogsListItemResponse } from 'app/console-api/deals/deals-logs';
import { BodyText, FlexColumn, formatDate, TableData, TableRow } from '@make-software/cspr-design';
import React from 'react';
import { StyledCardRow } from 'app/components/common/common-styles';

export interface DealsLogsItemProps {
  data: DealsLogsListItemResponse;
}

export const DealsLogsItem = ({ data }: DealsLogsItemProps) => {
  return (
    <StyledCardRow key={data.logData.id}>
      <TableData>
        <FlexColumn>
          <BodyText size={3} monotype>
            {formatDate(data.logData.timestamp.toLocaleString())}
          </BodyText>
        </FlexColumn>
      </TableData>
      <TableData>
        <FlexColumn>
          <BodyText size={2} monotype>
            {data.logData.action}
          </BodyText>
          <BodyText size={3} monotype variation={'darkGray'}>
            {data.logData.description}
          </BodyText>
        </FlexColumn>
      </TableData>
      <TableData>
        <FlexColumn>
          <BodyText size={3} monotype>
            {data.tsName}
          </BodyText>
        </FlexColumn>
      </TableData>
    </StyledCardRow>
  );
};
